import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { motion } from "framer-motion";
import SEO from "@/components/SEO";

export default function AdminLogin() {
  const navigate = useNavigate();
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    // If returning via OAuth callback (hash contains session_id), don't run /me check
    if (window.location.hash?.includes("session_id=")) {
      setChecking(false);
      return;
    }
    api.get("/auth/me")
      .then((r) => {
        if (r.data.is_admin) navigate("/admin", { replace: true });
        else setChecking(false);
      })
      .catch(() => setChecking(false));
  }, [navigate]);

  const handleLogin = () => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + "/admin";
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  if (checking) {
    return (
      <div className="min-h-screen bg-[#F4F4F0] flex items-center justify-center font-body text-sm text-neutral-500" data-testid="admin-login-checking">
        Checking session…
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#F4F4F0] text-[#0A0A0A] flex flex-col" data-testid="admin-login-page">
      <SEO title="Admin — Studio/Saar" noindex />
      <header className="px-6 md:px-12 lg:px-24 py-6 flex items-center justify-between border-b border-neutral-300">
        <a href="/" className="font-display font-black text-lg tracking-tight">
          STUDIO/SAAR<span className="text-[#FF3E00]">®</span>
        </a>
        <span className="font-body text-xs uppercase tracking-[0.25em] text-neutral-500">
          Admin Access
        </span>
      </header>

      <main className="flex-1 flex items-center px-6 md:px-12 lg:px-24">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10 w-full">
          <div className="md:col-span-7">
            <motion.h1
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.7 }}
              className="font-display font-black uppercase tracking-tighter text-5xl sm:text-7xl lg:text-[7vw] leading-[0.9]"
            >
              The<br />
              <span className="font-serif-italic font-light normal-case lowercase text-[#FF3E00]">private</span><br />
              studio.
            </motion.h1>
          </div>
          <div className="md:col-span-4 md:col-start-9 flex flex-col justify-end gap-6">
            <p className="font-body text-base text-neutral-700">
              Sign in with your authorised Google account to manage projects and review contact messages.
            </p>
            <button
              onClick={handleLogin}
              className="self-start font-display font-bold uppercase tracking-widest text-sm bg-[#0A0A0A] text-[#F4F4F0] px-8 py-5 hover:bg-[#FF3E00] transition-colors duration-300"
              data-testid="google-login-button"
            >
              Sign in with Google →
            </button>
            <p className="font-body text-xs text-neutral-500">
              Access is restricted to whitelisted email addresses.
            </p>
          </div>
        </div>
      </main>
    </div>
  );
}
